import { useEffect, useState } from "react";
import { Slide, Fade, AttentionSeeker } from "react-awesome-reveal";
import aboutImgBg from "../../images/about-bg.svg";
import { staticLinks } from "../../data/Links";

import "./AboutMe.css";

const AboutMe = () => {
  const [links, setLinks] = useState({});

  useEffect(() => {
    if (localStorage.getItem("links") == null) {
      const fetchLinks = async () => {
        const resp = await fetch(staticLinks.firebaseBaseUrl + "/links.json");
        const data = await resp.json();
        localStorage.setItem("links", JSON.stringify(data));
        setLinks(data);
      };
      fetchLinks();
    } else {
      setLinks(JSON.parse(localStorage.getItem("links")));
    }
  }, []);

  return (
    <>
      <div id="about" className="container-fluid about py-5">
        <div className="row">
          <div className="col-lg-5 col-xm-12">
            <div className="about__photo-wrap mb-5">
              <Slide duration="1700">
                <img className="about__profile-img" src={links.myPhoto || staticLinks.myPhoto} />
              </Slide>
            </div>
          </div>

          <div className="col-lg-6 col-xm-12 about-div">
            <AttentionSeeker effect="jello">
              <h1 className="about__heading">about me</h1>
            </AttentionSeeker>
            <img class="about-bg" src={aboutImgBg} alt=""></img>
            <Fade cascade className="about__content" duration="500">
              <p>
                Hello! I'm <strong className="my-name">Sushant</strong>
              </p>

              <p>
                A passionate <strong>Senior Software Engineer</strong> with{" "}
                <strong>5+ years of experience</strong>, currently working at{" "}
                <strong>Accenture</strong> on the <strong>Disney</strong> project,
                building scalable backend applications using <strong>Java</strong>,{" "}
                <strong>Spring Boot</strong>, <strong>MySQL</strong>, and{" "}
                <strong>Google Cloud Platform (GCP)</strong>.
              </p>

              <p>
                My professional journey began at{" "}
                <strong>Infibeam Avenues Ltd.</strong>, where I spent{" "}
                <strong>3+ years</strong> developing secure{" "}
                <strong>Payment Gateway Systems</strong>. Working on high-volume
                financial transactions taught me the importance of reliability,
                performance, and designing software that solves real-world problems.
              </p>

              <p>
                <strong>I love writing code</strong>. What started
                with my first program in <strong>Java</strong> has grown into a passion
                for designing <strong>Microservices</strong>, building{" "}
                <strong>REST APIs</strong>, and creating scalable distributed systems
                that power millions of users.
              </p>

              <p>
                <strong>Software Engineering</strong> is a never-ending puzzle that I
                genuinely enjoy solving. I love transforming complex business
                requirements into clean, maintainable, and efficient software through
                thoughtful architecture and continuous improvement.
              </p>

              <p>
                <strong>Always in learning mode</strong>. Whether it's{" "}
                <strong>System Design</strong>, <strong>Cloud Technologies</strong>, or{" "}
                <strong>Backend Architecture</strong>, I believe the best engineers
                never stop learning and always stay curious about how things work under
                the hood.
              </p>

              <p>
                I'm equally excited about the rise of <strong>Artificial Intelligence</strong>{" "}
                and how it's transforming software development. As an{" "}
                <strong>AWS Certified AI Practitioner</strong>, I enjoy learning how intelligent
                systems can enhance modern backend software.
              </p>

              <p>
                There’s always <strong>more to learn</strong>,{" "}
                <strong>more problems to solve</strong>, and{" "}
                <strong>more systems to build</strong>. And for this journey, I am{" "}
                <strong>GRATEFUL</strong>.
              </p>
            </Fade>
            <div className="text-center about-btns">
              {links.resumeView && (
                <a
                  href={links.resumeView}
                  target="_blank"
                  className="btn-outline"
                  style={{ cursor: "pointer" }}
                >
                  View Resume
                </a>
              )}
              {links.resumeDownload && (
                <a href={links.resumeDownload} className="btn-outline">
                  Download Resume
                </a>
              )}
              {links.cdac && (
                <a href={links.cdac} target="_blank" className="btn-outline">
                  CDAC Accredition
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutMe;
